import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22CustomStyles.tsx%22,%22import%22:%22Hanken_Grotesk%22,%22arguments%22:[{%22weight%22:[%22300%22,%22400%22,%22500%22,%22600%22,%22700%22],%22subsets%22:[%22latin%22]}],%22variableName%22:%22hankenGrotesk%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Hanken Grotesk', 'Hanken Grotesk Fallback'",
        fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
